import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {SliceNames} from "../constants";
import {IQuestionState} from "./Helper";
import {IQuestionAdmin} from "../../api/questionService";
import {createQuestion, deleteQuestion, getQuestions, updateQuestion} from "./ActionCreators";

const initialValue: IQuestionState = {
    items: [],
    fetchQuestionsLoading: false,
    actionLoading: false,
    fetchQuestionsRequestId: undefined,
}

const questionSlice = createSlice({
    name: SliceNames.QUESTION,
    initialState: initialValue,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(
            getQuestions.pending, (state, action) => {
                state.fetchQuestionsLoading = true
                state.fetchQuestionsRequestId = action.meta.requestId
            })
            .addCase(
                getQuestions.fulfilled, (state, action) => {
                    if (state.fetchQuestionsRequestId !== action.meta.requestId) {
                        return
                    }
                    state.items = action.payload
                    state.fetchQuestionsLoading = false
                    state.fetchQuestionsRequestId = undefined
                })
            .addCase(
                getQuestions.rejected, (state, action) => {
                    if (state.fetchQuestionsRequestId !== action.meta.requestId) {
                        return
                    }
                    state.fetchQuestionsLoading = false
                    state.fetchQuestionsRequestId = undefined
                })
            .addCase(
                createQuestion.pending, (state) => {
                    state.actionLoading = true
                })
            .addCase(
                createQuestion.fulfilled, (state, action: PayloadAction<IQuestionAdmin>) => {
                    state.items = [action.payload, ...state.items]
                    state.actionLoading = false
                })
            .addCase(
                createQuestion.rejected, (state) => {
                    state.actionLoading = false
                })
            .addCase(
                updateQuestion.pending, (state) => {
                    state.actionLoading = true
                })
            .addCase(
                updateQuestion.fulfilled, (state, action: PayloadAction<IQuestionAdmin>) => {
                    state.items = state.items.map((item) => (
                        item.id === action.payload.id ? action.payload : item
                    ))
                    state.actionLoading = false
                })
            .addCase(
                updateQuestion.rejected, (state) => {
                    state.actionLoading = false
                })
            .addCase(
                deleteQuestion.pending, (state) => {
                    state.actionLoading = true
                })
            .addCase(
                deleteQuestion.fulfilled, (state, action: PayloadAction<string>) => {
                    state.items = state.items.filter((item) => item.id !== action.payload)
                    state.actionLoading = false
                })
            .addCase(
                deleteQuestion.rejected, (state) => {
                    state.actionLoading = false
                })
    }
})

export default questionSlice.reducer
